var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAddPhotoRg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "69px",
    viewBox: "0 0 68 69",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icAddPhotoRg@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Last-Step-Copy-2",
    transform: "translate(-154.000000, -239.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-New-image",
    transform: "translate(126.000000, 211.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.5,61.0895141 L79.856,61.0895141 C80.6844271,61.0895141 81.356,61.7610869 81.356,62.5895141 C81.356,63.4179412 80.6844271,64.0895141 79.856,64.0895141 L63.5,64.0895141 L63.5,81.7902813 C63.5,82.6187085 62.8284271,83.2902813 62,83.2902813 C61.1715729,83.2902813 60.5,82.6187085 60.5,81.7902813 L60.5,64.0895141 L44.144,64.0895141 C43.3155729,64.0895141 42.644,63.4179412 42.644,62.5895141 C42.644,61.7610869 43.3155729,61.0895141 44.144,61.0895141 L60.5,61.0895141 L60.5,46.1317136 C60.5,45.3032864 61.1715729,44.6317136 62,44.6317136 C62.8284271,44.6317136 63.5,45.3032864 63.5,46.1317136 L63.5,61.0895141 Z M81.096,93.5063939 C87.3969635,93.5063939 92.7666179,88.2457186 92.988,82.0396419 L92.988,43.3887468 C92.988,36.9838845 87.7057301,31.6726343 81.344,31.6726343 L42.904,31.6726343 C36.5422699,31.6726343 31.26,36.9838845 31.26,43.3887468 L31.26,81.7902813 C31.26,88.1951436 36.5422699,93.5063939 42.904,93.5063939 L81.096,93.5063939 Z M81.096,96.5063939 L42.904,96.5063939 C34.8817301,96.5063939 28.26,89.8483346 28.26,81.7902813 L28.26,43.3887468 C28.26,35.3306935 34.8817301,28.6726343 42.904,28.6726343 L81.344,28.6726343 C89.3662699,28.6726343 95.988,35.3306935 95.988,43.3887468 L95.9870547,82.0928875 C95.7077351,89.9567448 89.0224049,96.5063939 81.096,96.5063939 Z",
    id: "icAddPhotoRg"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddPhotoRg);
export default __webpack_public_path__ + "static/media/icAddPhotoRg.3688450612c398efa7caf60169d5511c.svg";
export { ForwardRef as ReactComponent };